import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DatesService {
  constructor(public _http: HttpClient) {}

  getFechaByWeek(params: any): Observable<any> {
    let ruta = environment.fechaByWeek + '/' + params;
    return this._http.get(ruta);
  }

  getWeeksByYear(params: any) {
    let ruta = environment.weeksByYear + '/' + params;
    return this._http.get(ruta);
  }
  getCurrentDate() {
    let ruta = environment.getCurrentDate;
    return this._http.get(ruta);
  }
  getCurrentWeek() {
    let ruta = environment.getCurrentWeek;
    return this._http.get(ruta);
  }

  getFechaByWeekAndYear(annio: number, semana: number): Observable<any> {
    let ruta = environment.fechaByWeekAndYear + annio + '/' + semana;
    return this._http.get(ruta);
  }

  getYears() {
    const initDate = 2024; // Año inicial
    const today = new Date(); // Fecha actual
    const currentYear = today.getFullYear(); // Año actual
    const lastDayOfYear = new Date(currentYear, 11, 31); // Último día del año actual
    const daysUntilEndOfYear = (lastDayOfYear.getTime() - today.getTime()) / (1000 * 60 * 60 * 24); // Días restantes del año actual
    
    const years: number[] = [];
    
    // Generar lista de años desde el año inicial hasta el actual
    for (let year = initDate; year <= currentYear; year++) {
      years.push(year);
    }
  
    // Si faltan 6 días o menos para que acabe el año, agregar el próximo año
    if (daysUntilEndOfYear <= 6) {
      years.push(currentYear + 1);
    }
  
    return years;
  }
}
